import React from "react";
import { createRoot } from "react-dom/client";

import BulkUpdate from "./components/BulkUpdate";
import ExportSpreadsheet from "./components/ExportSpreadsheet";
import ExportContacts from "./components/ExportSpreadsheet/ExportContacts";
import Duplicate from "./components/Duplicate/index.jsx";

function bulkUpdateInit() {
  document.querySelectorAll("#bulk-update-root").forEach((element) => {
    const root = createRoot(element);
    root.render(<BulkUpdate />);
  });
}

exportSpreadsheetInit();

function exportSpreadsheetInit() {
  document.querySelectorAll("#export-spreadsheet-root").forEach((element) => {
    const root = createRoot(element);
    const { email, allIds: allIdsRaw, role } = element.dataset;
    const allIds = allIdsRaw ? JSON.parse(allIdsRaw) : "";
    root.render(
      <ExportSpreadsheet email={email} allIds={allIds} role={role} />
    );
  });
}

exportContactsInit();

function exportContactsInit() {
  document.querySelectorAll("#export-contacts-root").forEach((element) => {
    const root = createRoot(element);
    const { email, allIds: allIdsRaw } = element.dataset;
    const allIds = allIdsRaw ? JSON.parse(allIdsRaw) : "";
    root.render(<ExportContacts email={email} allIds={allIds} />);
  });
}

bulkUpdateInit();

function duplicateInit() {
  document.querySelectorAll("#duplicate").forEach((element) => {
    const root = createRoot(element);
    root.render(<Duplicate uid={element.dataset.uid} />);
  });
}

duplicateInit();
